var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"badge"},_vm.$listeners),[(_vm.icon)?_c('Icon',{staticClass:"badge__icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }